// ── AR Flow — NOVA INTERFACE: 📷 Biblioteca (fotos reais das lojas) ─────────
// Fotos tiradas nas lojas, ligadas ao produto do catálogo: pronta entrega,
// mostruário ou "já passou pela loja". Todas as lojas veem todas as fotos,
// sempre com a loja de cada uma. O consultor adiciona pelo celular escolhendo
// o produto numa lista (sem precisar nomear arquivo).
// Fala só com o servidor do CRM (/api/biblioteca e /api/produtos/sugestoes).

import { useEffect, useRef, useState } from "react";
import { AVISO_VALOR } from "./CatalogoBusca";
import { CATEGORIAS, EmPreparacao, lerJson, reduzirFoto } from "./Produtos";
import useCatalogStatus from "./useCatalogStatus";

const DISPLAY = "'Bricolage Grotesque', 'Source Sans 3', system-ui, sans-serif";
export const ETIQUETAS = [["pronta_entrega", "Pronta entrega"], ["mostruario", "Mostruário"], ["ja_passou_pela_loja", "Já passou pela loja"]];
const NOME_ETIQUETA = Object.fromEntries(ETIQUETAS);
export const LOCAIS = [["SHOPPING", "Shopping"], ["MEZZO", "Mezzo"], ["DECORACAO", "Decoração"]];
const NOME_LOCAL = v => (LOCAIS.find(([k]) => k === String(v || "").toUpperCase())?.[1] || String(v || ""));

function NovaFoto({ th, stores, currentUser, onFechar, onSalva }) {
  const line = th.nuLine || th.sandDark;
  const podeEscolherLoja = ["admin", "superadmin"].includes(currentUser.role);
  const [q, setQ] = useState("");
  const [sugestoes, setSugestoes] = useState([]);
  const [produto, setProduto] = useState(null);
  const [foraDoCatalogo, setForaDoCatalogo] = useState(false);
  const [etiqueta, setEtiqueta] = useState("");
  const [observacao, setObservacao] = useState("");
  const [storeId, setStoreId] = useState(currentUser.storeId || "");
  const [foto, setFoto] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const input = useRef(null);

  useEffect(() => {
    if (foraDoCatalogo || produto || q.trim().length < 2) { setSugestoes([]); return; }
    let vivo = true;
    const t = setTimeout(() => {
      fetch(`/api/produtos/sugestoes?q=${encodeURIComponent(q.trim())}`, { credentials: "include" }).then(lerJson)
        .then(d => vivo && setSugestoes(d.itens || [])).catch(() => vivo && setSugestoes([]));
    }, 250);
    return () => { vivo = false; clearTimeout(t); };
  }, [q, produto, foraDoCatalogo]);

  const salvar = async () => {
    if (salvando) return;
    if (!foto) { setErro("Tire ou escolha a foto."); return; }
    if (!produto && !(foraDoCatalogo && q.trim())) { setErro("Escolha o produto na lista (ou marque que não está no catálogo e escreva o nome)."); return; }
    if (!etiqueta) { setErro("Escolha a etiqueta."); return; }
    if (podeEscolherLoja && !Number(storeId)) { setErro("Escolha a loja da foto."); return; }
    setSalvando(true); setErro("");
    try {
      const r = await fetch("/api/biblioteca/fotos", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ produtoId: produto?.id || null, produtoNome: produto ? null : q.trim(), etiqueta, observacao, storeId: podeEscolherLoja ? Number(storeId) || null : undefined, imagemBase64: foto }) });
      await lerJson(r);
      onSalva();
    } catch (e) { setErro(e.message); } finally { setSalvando(false); }
  };

  const campo = { padding: "9px 10px", borderRadius: 4, border: `1px solid ${line}`, fontFamily: "inherit", fontSize: 15, background: "#fff", color: th.text, width: "100%", boxSizing: "border-box" };
  const passo = { fontSize: 13, fontWeight: 700, color: th.muted, margin: "14px 0 6px" };
  return (
    <div role="dialog" aria-modal="true" aria-label="Adicionar foto" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", zIndex: 60, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div style={{ width: "min(520px, 100%)", maxHeight: "92vh", overflowY: "auto", background: "#fff", borderRadius: "8px 8px 0 0", padding: "16px 18px 24px", boxSizing: "border-box", color: th.text }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontFamily: DISPLAY, fontSize: 20, fontWeight: 700 }}>Adicionar foto</div>
          <button type="button" onClick={onFechar} style={{ border: `1px solid ${line}`, background: "none", borderRadius: 4, padding: "6px 10px", cursor: "pointer", fontFamily: "inherit" }}>Cancelar</button>
        </div>

        <div style={passo}>1. Foto</div>
        <input ref={input} type="file" aria-label="Foto da Biblioteca" accept="image/*" capture="environment" style={{ display: "none" }}
          onChange={async e => { const f = e.target.files?.[0]; e.target.value = ""; if (!f) return; try { setFoto(await reduzirFoto(f, 1600)); setErro(""); } catch (err) { setErro(err.message); } }} />
        {foto ? (
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <img src={foto} alt="Foto escolhida" style={{ height: 90, borderRadius: 4, border: `1px solid ${line}` }} />
            <button type="button" onClick={() => input.current?.click()} style={{ ...campo, width: "auto", cursor: "pointer" }}>Trocar</button>
          </div>
        ) : (
          <button type="button" onClick={() => input.current?.click()} style={{ ...campo, cursor: "pointer", fontWeight: 700 }}>📷 Tirar ou escolher foto</button>
        )}
        <div style={{ fontSize: 12, color: th.muted, marginTop: 4 }}>Só o produto: sem rosto de cliente na foto.</div>

        <div style={passo}>2. Produto</div>
        {produto ? (
          <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center", border: `1px solid ${line}`, borderRadius: 4, padding: "8px 10px" }}>
            <span><strong>{produto.nome}</strong> <span style={{ color: th.muted, fontSize: 13 }}>{produto.fornecedor}</span></span>
            <button type="button" onClick={() => { setProduto(null); setQ(""); }} style={{ border: "none", background: "none", color: th.accent, cursor: "pointer", fontFamily: "inherit" }}>trocar</button>
          </div>
        ) : (
          <>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder={foraDoCatalogo ? "Nome do produto" : "Digite o nome (ex.: Pulse)"} style={campo} />
            {sugestoes.length > 0 && (
              <div style={{ border: `1px solid ${line}`, borderTop: "none", borderRadius: "0 0 4px 4px" }}>
                {sugestoes.slice(0, 8).map(s => (
                  <button key={s.id} type="button" onClick={() => { setProduto(s); setSugestoes([]); }} style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", borderTop: `1px solid ${line}`, padding: "9px 10px", cursor: "pointer", fontFamily: "inherit", fontSize: 14 }}>
                    <strong>{s.nome}</strong> <span style={{ color: th.muted, fontSize: 13 }}>{s.fornecedor}</span>
                  </button>
                ))}
              </div>
            )}
            <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, marginTop: 6, color: th.muted }}>
              <input type="checkbox" checked={foraDoCatalogo} onChange={e => setForaDoCatalogo(e.target.checked)} /> Não está no catálogo
            </label>
          </>
        )}

        <div style={passo}>3. Etiqueta</div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {ETIQUETAS.map(([v, n]) => (
            <button key={v} type="button" aria-pressed={etiqueta === v} onClick={() => setEtiqueta(v)} style={{ border: `1px solid ${etiqueta === v ? th.accent : line}`, background: etiqueta === v ? th.accent : "#fff", color: etiqueta === v ? "#fff" : th.text, borderRadius: 99, padding: "7px 12px", cursor: "pointer", fontFamily: "inherit", fontSize: 14 }}>{n}</button>
          ))}
        </div>

        {podeEscolherLoja && (
          <>
            <label htmlFor="biblioteca-foto-loja" style={{ ...passo, display:"block" }}>Loja</label>
            <select id="biblioteca-foto-loja" value={storeId} onChange={e => setStoreId(e.target.value)} style={campo}>
              <option value="">Escolha a loja</option>
              {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </>
        )}

        <div style={passo}>Tecido, cor ou observação (opcional)</div>
        <input value={observacao} onChange={e => setObservacao(e.target.value)} maxLength={200} placeholder="Ex.: linho cinza, 2,30 m" style={campo} />

        {erro && <div role="alert" style={{ marginTop: 12, color: "#991B1B", fontSize: 14 }}>{erro}</div>}
        <button type="button" onClick={salvar} disabled={salvando} style={{ marginTop: 16, width: "100%", border: "none", borderRadius: 4, padding: "12px", background: th.accent, color: "#fff", fontWeight: 700, fontSize: 15, cursor: salvando ? "default" : "pointer", fontFamily: "inherit" }}>
          {salvando ? "Salvando…" : "Salvar foto"}
        </button>
      </div>
    </div>
  );
}

export default function Biblioteca({ theme, stores, currentUser }) {
  const th = theme;
  const line = th.nuLine || th.sandDark;
  const status = useCatalogStatus();
  const conectado = status.conectado;
  const [filtros, setFiltros] = useState({ local: "", categoria: "", etiqueta: "", q: "" });
  const [fotos, setFotos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");
  const [nova, setNova] = useState(false);
  const [ampliada, setAmpliada] = useState(null);
  const [recarga, setRecarga] = useState(0);

  useEffect(() => {
    if (!conectado) return;
    let vivo = true;
    setCarregando(true); setErro("");
    const p = new URLSearchParams(Object.entries(filtros).filter(([, v]) => v));
    const t = setTimeout(() => {
      fetch(`/api/biblioteca?${p}`, { credentials: "include" }).then(lerJson)
        .then(d => vivo && setFotos(d.fotos || [])).catch(e => vivo && setErro(e.message)).finally(() => vivo && setCarregando(false));
    }, 250);
    return () => { vivo = false; clearTimeout(t); };
  }, [conectado, filtros, recarga]);

  const apagar = async f => {
    if (!window.confirm("Apagar esta foto da Biblioteca?")) return;
    try { await lerJson(await fetch(`/api/biblioteca/fotos/${encodeURIComponent(f.id)}`, { method: "DELETE", credentials: "include" })); setAmpliada(null); setRecarga(n => n + 1); }
    catch (e) { setErro(e.message); }
  };
  const podeApagar = f => currentUser.role === "admin" || Number(f.autorId) === Number(currentUser.id)
    || (currentUser.role === "manager" && Number(f.storeId) === Number(currentUser.storeId));
  const nomeLoja = id => stores.find(s => Number(s.id) === Number(id))?.name || "";
  // Fotos do Drive vêm com o local (Shopping, Mezzo, Decoração); as do CRM, com a loja.
  const localDe = f => (f.local ? `📍 ${NOME_LOCAL(f.local)}` : (nomeLoja(f.storeId) ? `📍 ${nomeLoja(f.storeId)}` : ""));
  const campo = { padding: "8px 10px", borderRadius: 4, border: `1px solid ${line}`, fontFamily: "inherit", fontSize: 14, background: "#fff", color: th.text };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontFamily: DISPLAY, fontSize: 26, fontWeight: 700, color: th.text }}>Biblioteca</div>
          <div style={{ fontSize: 14, color: th.muted }}>Fotos reais das nossas lojas, para mandar ao cliente.</div>
            <div style={{ fontSize: 12, color: th.muted, marginTop: 3 }}>{AVISO_VALOR}</div>
        </div>
        <button type="button" disabled={!conectado} onClick={() => setNova(true)} style={{ border: "none", borderRadius: 4, padding: "10px 16px", background: th.accent, color: "#fff", fontWeight: 700, fontSize: 14, cursor: conectado ? "pointer" : "default", opacity: conectado ? 1 : 0.5, fontFamily: "inherit" }}>📷 Adicionar foto</button>
      </div>

      {(status.state === "verificando" || status.state === "retentando") && (
        <div role="status" style={{ marginTop: 10, color: th.muted, fontSize: 13 }}>
          {status.state === "retentando" ? "A verificação demorou ou falhou; tentando novamente…" : "Verificando a conexão do catálogo…"}
        </div>
      )}
      {status.state === "falha" && (
        <div style={{ marginTop: 10 }}>
          <div role="alert" style={{ color: "#991B1B", fontSize: 13 }}>Não foi possível verificar a conexão do catálogo: {status.error}</div>
          <button type="button" onClick={status.retry} style={{ marginTop: 6, border: `1px solid ${line}`, background: "#fff", borderRadius: 4, padding: "7px 10px", cursor: "pointer" }}>Verificar catálogo novamente</button>
        </div>
      )}
      {status.state === "desconectado" && <button type="button" onClick={status.retry} style={{ marginTop: 10, border: `1px solid ${line}`, background: "#fff", borderRadius: 4, padding: "7px 10px", cursor: "pointer" }}>Verificar catálogo novamente</button>}
      {conectado === false && (
        <div style={{ marginTop: 14 }}>
          <EmPreparacao th={th} titulo="Biblioteca em preparação"
            texto="Aqui vão ficar as fotos reais das lojas (pronta entrega, mostruário e o que já passou por aqui), ligadas ao catálogo. Assim que o catálogo estiver conectado, é só tocar em “+ Foto”." />
        </div>
      )}

      {conectado && (
        <>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "14px 0" }}>
            <input aria-label="Buscar produto" value={filtros.q} onChange={e => setFiltros(f => ({ ...f, q: e.target.value }))} placeholder="Buscar produto" style={{ ...campo, flex: "1 1 180px" }} />
            <select aria-label="Local" value={filtros.local} onChange={e => setFiltros(f => ({ ...f, local: e.target.value }))} style={campo}>
              <option value="">Todos os locais</option>{LOCAIS.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
            </select>
            <select aria-label="Categoria" value={filtros.categoria} onChange={e => setFiltros(f => ({ ...f, categoria: e.target.value }))} style={campo}>
              {CATEGORIAS.map(([v, n]) => <option key={v} value={v}>{v ? n : "Todas as categorias"}</option>)}
            </select>
            <select aria-label="Etiqueta" value={filtros.etiqueta} onChange={e => setFiltros(f => ({ ...f, etiqueta: e.target.value }))} style={campo}>
              <option value="">Todas as etiquetas</option>{ETIQUETAS.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
            </select>
          </div>
          {erro && <div role="alert" style={{ marginBottom: 12, color: "#991B1B", fontSize: 14 }}>{erro}</div>}
          {carregando && <div style={{ color: th.muted, fontSize: 14 }}>Carregando fotos…</div>}
          {!carregando && fotos.length === 0 && !erro && <div style={{ color: th.muted, fontSize: 14 }}>Nenhuma foto com esses filtros ainda.</div>}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 10 }}>
            {fotos.map(f => (
              <button key={f.id} type="button" onClick={() => setAmpliada(f)} style={{ textAlign: "left", background: "#fff", border: `1px solid ${line}`, borderRadius: 4, padding: 0, cursor: "pointer", fontFamily: "inherit", overflow: "hidden", color: th.text }}>
                <img src={f.miniaturaUrl || f.url} alt={f.produtoNome || ""} loading="lazy" style={{ width: "100%", aspectRatio: "1 / 1", objectFit: "cover", display: "block" }} />
                <div style={{ padding: "7px 9px 9px" }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{f.produtoNome}</div>
                  <div style={{ fontSize: 12, color: th.muted }}>{[localDe(f), NOME_ETIQUETA[f.etiqueta]].filter(Boolean).join(" · ")}</div>
                </div>
              </button>
            ))}
          </div>
        </>
      )}

      {ampliada && (
        <div role="dialog" aria-modal="true" aria-label={ampliada.produtoNome || "Foto"} onClick={() => setAmpliada(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.7)", zIndex: 60, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 6, maxWidth: 720, width: "100%", maxHeight: "92vh", overflowY: "auto", color: th.text }}>
            <img src={ampliada.url} alt={ampliada.produtoNome || ""} style={{ width: "100%", display: "block" }} />
            <div style={{ padding: "12px 14px", display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              <div>
                <div style={{ fontWeight: 700 }}>{ampliada.produtoNome}</div>
                <div style={{ fontSize: 13, color: th.muted }}>{[localDe(ampliada), NOME_ETIQUETA[ampliada.etiqueta], ampliada.observacao].filter(Boolean).join(" · ")}</div>
                <div style={{ fontSize: 12, color: th.muted, marginTop: 4 }}>{AVISO_VALOR}</div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                {podeApagar(ampliada) && <button type="button" onClick={() => apagar(ampliada)} style={{ ...campo, cursor: "pointer", color: "#991B1B" }}>Apagar</button>}
                <button type="button" onClick={() => setAmpliada(null)} style={{ ...campo, cursor: "pointer" }}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {nova && <NovaFoto th={th} stores={stores} currentUser={currentUser} onFechar={() => setNova(false)} onSalva={() => { setNova(false); setRecarga(n => n + 1); }} />}
    </div>
  );
}
